import React from "react";
import { TextField, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import "./TextfieldCustom.css";
import { useSelector } from "react-redux";

const TextFieldCustom = ({
  showSearchIcon = false,
  endIcon = null,
  multiline = false,
  rows = multiline ? 4 : undefined,
  customClass = "custom-textfield",
  heightClass = "custom-textfield-default-height",
  disableClass="",
  ...props
}) => {
  const theme = useSelector((state) => state.theme.mode);
  return (
    <TextField
      {...props}
      placeholder={showSearchIcon || props.placeholder ? props.placeholder : ""}
      multiline={multiline}
      rows={rows}
      className={`${customClass} ${heightClass} ${disableClass}`}
      onChange={(e) => {
        const value = e.target.value;
        const trimmedLeft = value.replace(/^\s+/, "");
        props.onChange?.({
          ...e,
          target: { ...e.target, value: trimmedLeft },
        });
      }}
      InputProps={{
        startAdornment: showSearchIcon ? (
          <InputAdornment position="start">
            <SearchIcon className="icon-color" />
          </InputAdornment>
        ) : null,
        endAdornment: endIcon ? (
          <InputAdornment position="end">{endIcon}</InputAdornment>
        ) : null,
        //     sx: {
        //   "& .MuiOutlinedInput-notchedOutline": {
        //     border: theme === "dark" ? "none" :"",
        //   },
        // },
        ...props.InputProps,
      }}
    />
  );
};

export default TextFieldCustom;
